<template>
  <v-container class="fill-height">
    <v-row class="text-center" justify="center" align="center">
      <v-col class="mb-4" cols="12" v-show="!finalImage && !isEditing">
        <div class="headline">
          Wähle ein Foto aus deiner Fotogallery oder mache ein Selfie.
        </div>
      </v-col>

      <v-col
          class="mb-1"
          cols="12"
      >
        <v-card
            flat
            :loading="loading"
            :disabled="loading"
        >
          <v-row justify="center">
            <v-col
                class=""
                cols="12"
                sm="8"
                md="6"
                lg="5"
                xl="4"
            >
              <image-clipper
                  overlay-image="img/onlineoverlay.png"
                  @editing="onEditing"
                  @finished="onFinishedEditing"
              />
            </v-col>
            <v-col
                v-show="finalImage && !isEditing"
                cols="12"
                md="6"
                lg="6"
                xl="4"
            >
              <upload-form @submit="onFormSubmit" :loading="loading"/>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ImageClipper from "./ImageClipper";
import UploadForm from "./UploadForm";
import { mapState } from 'vuex'
const fb = require('@/firebase/config.js');


// import OrderAmount from "./OrderAmout";

export default {
  name: 'Designer',
  components: {UploadForm, ImageClipper},
  data: () => ({
    isEditing: false,
    finalImage: null,
    loading: false,
  }),
  computed: {
      ...mapState('user', {
        loggedin: state => state.loggedin,
        user: state => state.user,
        userClaims: state => state.claims,
      })
  },
  methods: {
    onEditing(args) {
      this.isEditing = true;
      console.log('onEditing', args);

      // this.$analytics.logEvent("screen_view_designing");

    },
    onFinishedEditing(image) {
      this.isEditing = false;
      console.log(image);
      this.finalImage = image.data;
      // this.$analytics.logEvent("screen_view_form");
    },
    onFormSubmit: async function (data) {
      console.log(data)

      // let item_songgl = {
      //   item_id: 'songgl',
      //   item_name: 'Songgl',
      //   item_category: '',
      //   item_variant: '',
      //   item_brand: 'Lustenau Marketing',
      //   price: data.order.price
      // };
      // const purchase = {
      //   transaction_id: '1',
      //   affiliation: '',
      //   currency: 'EUR',
      //   value: data.order.total, // Total Revenue
      //   tax: data.order.total - data.order.total/1.2,
      //   shipping: 0,
      //   coupon: '',
      //   items: [item_songgl]
      // };
      // this.$analytics.logEvent("add_to_cart", {value: data.order.total, currency: "EUR", items: [{...{item_songgl}, quantity: data.order.quantity }]});
      // this.$analytics.logEvent("purchase", purchase);

      this.loading = true
      const self = this

      const img = {
        name: data.person.email + '_' + new Date().getTime() + '.jpg',
        dataUrl: this.finalImage,
      }

      const metadata = { ...data.person, ...data.order, payment: data.payment }
      //
      // const fileUploaded = this.$store.dispatch('uploadFile', { file: img, metadata: metadata })
      //     .then((result) => {
      //       console.log('upload finished', result)
      //       //this.$emit('success', {type: this.type, file: this.uploadFile})
      //       self.uploadFile = null
      //       //self.fileUrl = result.url;
      //
      //       return true
      //
      //     })
      //     .catch((error) => {
      //       console.log('error', error)
      //       //this.$emit('error', error.code)
      //       alert('Fehler: ' + error.code)
      //       return false
      //       // self.$analytics.logEvent('exception', { description: error.code})
      //     })
      //     .finally(() => {
      //       self.loading = false
      //     })

      // neuer Upload 2024
      const imageUpload = fb.fire.app().functions('europe-west1').httpsCallable('uploadOrder')
      const uploadData = { image: img, metadata: metadata }
      const fileUploaded = await imageUpload(uploadData)
          .then((result) => {
            console.log('upload finished', result)
            // get oder code
            if (result.data.status === 'success') {
              return result.data.data
            } else {
              return null
            }

          })
          .catch((error) => {
            console.log('error', error)
            return false
          })
          .finally(() => {
            self.loading = false
          })

      console.log('fileupload-data', fileUploaded)
      if (fileUploaded) {
          if (fileUploaded.metadata.payment.payment === 'paylater') {
            window.location = '//' + window.location.host + '/' + fileUploaded.redirectUrl + `?orderId=${fileUploaded.orderId}`
          } else {
            window.location = fileUploaded.redirectUrl
          }


        // // if stripe
        // // route to stripe
        // if (data.payment === 'paynow') {
        //   console.log('paynow')
        //   const stripeCreatePaymentSession = fb.fire.app().functions('europe-west1').httpsCallable('createPaymentSession')
        //   await stripeCreatePaymentSession(metadata)
        //       .then((result) => {
        //         console.log('result from Stripe create payment', result)
        //       })
        //       .catch((error) => {
        //         console.log('error', error)
        //       })
        // } else {
        //   console.log('paylater')
        //   await self.$router.push('Thankyou')
        // }


        // else redirekt to thankyou
        // self.$router.push('Thankyou')
      }
    }
  }
}
</script>
